const AdminAuthCheck = async () => {
  const token = localStorage.getItem("admin_box_dollar");
  try {
    const resp = await fetch("/admin/auth/check", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Admin Auth Check" + error);
    return { status: false, message: "Internet Server Error" };
  }
};

const AdminLogin = async (body) => {
  try {
    const resp = await fetch("/admin/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    console.error("Admin Login" + error);
    return { status: false, message: "Internet Server Error" };
  }
};

const updateAdminPw = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/admin/change/pw`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

// User
const GetAllUserData = async (
  page,
  startDate,
  endDate,
  limit,
  q,
  sort,
  block,
  id,
  filterType = "created", // 'created' or 'updated'
  activeSort = false // true → sort by updatedAt
) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    // 🧩 Build dynamic query string
    const queryParams = new URLSearchParams({
      page,
      limit,
      q,
      sort,
      block,
      startDate,
      endDate,
      filterType,
      activeSort,
    });

    if (id) queryParams.append("id", id);

    const resp = await fetch(`/api/app/user/admin?${queryParams.toString()}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return await resp.json();
  } catch (error) {
    console.log(error);
    return { status: false, message: "Internet Server Error" };
  }
};

// User
const GetAllUserExal = async (startDate, endDate) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    // 🧩 Build dynamic query string
    const queryParams = new URLSearchParams({
      startDate,
      endDate,
    });

    const resp = await fetch(
      `/api/app/user/admin/excel?${queryParams.toString()}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return await resp.json();
  } catch (error) {
    console.log(error);
    return { status: false, message: "Internet Server Error" };
  }
};

const BlockUser = async (id, status) => {
  const token = localStorage.getItem("admin_box_dollar");
  const body = {
    status,
  };
  try {
    const resp = await fetch(`/api/app/user/admin/block/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    console.log(error);
    return { status: false, message: "Internet Server Error" };
  }
};

const DeleteUser = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");
  try {
    const resp = await fetch(`/api/app/user/admin`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,

        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    console.log(error);
    return { status: false, message: "Internet Server Error" };
  }
};

// User Profile Update
const UpdateUserInfo = async (id, body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/user/profile/admin/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    console.log(error);
    return { status: false, message: "Internet Server Error" };
  }
};

// LeaderBoard Get
const GetLeaderBoard = async (page, limit) => {
  const token = localStorage.getItem("admin_box_dollar");
  try {
    const resp = await fetch(
      `/api/app/user/admin/top/leaderbord?page=${page}&limit=${limit}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return await resp.json();
  } catch (error) {
    console.log(error);
    return { status: false, message: "Internet Server Error" };
  }
};

// Admin Dashbord
const AdminDashbord = async (startDate, endDate, type) => {
  const token = localStorage.getItem("admin_box_dollar");
  try {
    const resp = await fetch(
      `/admin/dashbord?startDate=${startDate}&endDate=${endDate}&type=${type}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

// Controller
const GetController = async () => {
  const token = localStorage.getItem("admin_box_dollar");
  try {
    const resp = await fetch(`/api/controller/admin`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const SetFieldNumber = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/controller/admin/update/field/coin`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,

        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    console.log(error);
    return { status: false, message: "Internet Server Error" };
  }
};

const UpdateControllerStatus = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/controller/admin/update/status`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const UpdateControllerScratchRange = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/controller/admin/update/range/scratch`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const UpdateControllerCaptchaRange = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/controller/admin/update/range/captcha`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const setControllerFacebook = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");
  try {
    const resp = await fetch(`/api/controller/admin/facebook/change`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // Corrected 'Bearer'
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

// Native Ads
const getNativeAds = async () => {
  const token = localStorage.getItem("admin_box_dollar");
  try {
    const resp = await fetch(`/api/app/ads/native/admin/get`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const updateNativeAds = async (id, body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/native/update/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const addNativeAds = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/native/add`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const deleteNativeAds = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/native/admin/delete`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

// Full Screen Ads
const getFullScreenAds = async () => {
  const token = localStorage.getItem("admin_box_dollar");
  try {
    const resp = await fetch(`/api/app/ads/fullScreen/admin/get`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const updateFullScreenAds = async (id, body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/fullScreen/update/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const addFullScreenAds = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/fullScreen/add`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const deleteFullScreenAds = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/fullScreen/admin/delete`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

// Banner Ads
const getBannerAds = async () => {
  const token = localStorage.getItem("admin_box_dollar");
  try {
    const resp = await fetch(`/api/app/ads/banner/admin/get`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const updateBannerAds = async (id, body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/banner/update/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const addBannerAds = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/banner/add`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const deleteBannerAds = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/banner/admin/delete`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

// Inhouse Ads
const getInhouseAds = async () => {
  const token = localStorage.getItem("admin_box_dollar");
  try {
    const resp = await fetch(`/api/app/ads/inhouse/admin/get`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const updateInhouseAds = async (id, body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/inhouse/update/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const addInhouseAds = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/inhouse/add`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const deleteInhouseAds = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/inhouse/admin/delete`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

// Open Ads
const getOpenAds = async () => {
  const token = localStorage.getItem("admin_box_dollar");
  try {
    const resp = await fetch(`/api/app/ads/open/admin/get`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const addOpenAds = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/open/add`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const updateOpenAds = async (id, body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/open/update/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const deleteOpenAds = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/open/admin/delete`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

// Reward Ads
const getRewardAds = async () => {
  const token = localStorage.getItem("admin_box_dollar");
  try {
    const resp = await fetch(`/api/app/ads/reward/admin/get`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const addRewardAds = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/reward/add`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const updateRewardAds = async (id, body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/reward/update/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const deleteRewardAds = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/ads/reward/admin/delete`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

//Cash Task
const GetCashTask = async () => {
  const token = localStorage.getItem("admin_box_dollar");
  try {
    const resp = await fetch(`/api/cashtask/admin`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return await resp.json();
  } catch (error) {
    console.log(error);
    return { status: false, message: "Internet Server Error" };
  }
};

const InsertCashTask = async (formData) => {
  const token = localStorage.getItem("admin_box_dollar");
  try {
    const resp = await fetch(`/api/cashtask/admin/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const UpdateCashTask = async (formData, id) => {
  const token = localStorage.getItem("admin_box_dollar");
  try {
    const resp = await fetch(`/api/cashtask/admin/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const DeleteCashTask = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/cashtask/admin`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    console.log(error);
    return { status: false, message: "Internet Server Error" };
  }
};

// Withdraw User
const GetUserWithdraw = async (
  page,
  startDate,
  endDate,
  limit,
  q,
  id,
  status // ✅ New optional status filter
) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(
      `/api/app/user/admin/withdraw?page=${page}&limit=${limit}&q=${q}&startDate=${startDate}&endDate=${endDate}${
        id ? `&id=${id}` : ""
      }${status !== undefined && status !== "" ? `&status=${status}` : ""}`, // ✅ Include only if status is provided
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return await resp.json();
  } catch (error) {
    console.error(error);
    return { status: false, message: "Internet Server Error" };
  }
};

const DeleteUserWithdraw = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/user/admin/withdraw`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    console.log(error);
    return { status: false, message: "Internet Server Error" };
  }
};

const UserWithdrawAccept = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/user/admin/withdraw`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,

        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    console.log(error);
    return { status: false, message: "Internet Server Error" };
  }
};

// Withdraw Card// Inhouse Ads
const getWithdrawCard = async () => {
  const token = localStorage.getItem("admin_box_dollar");
  try {
    const resp = await fetch(`/api/app/user/withdraw/card/admin/get`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const updateWithdrawCard = async (id, body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/user/withdraw/card/update/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const addWithdrawCard = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/user/withdraw/card/add`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const deleteWithdrawCard = async (body) => {
  const token = localStorage.getItem("admin_box_dollar");

  try {
    const resp = await fetch(`/api/app/user/withdraw/card/admin/delete`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

module.exports = {
  AdminLogin,
  AdminAuthCheck,
  updateAdminPw,
  GetAllUserData,
  GetAllUserExal,
  BlockUser,
  DeleteUser,
  UpdateUserInfo,
  GetLeaderBoard,
  AdminDashbord,
  GetController,
  setControllerFacebook,
  UpdateControllerStatus,
  SetFieldNumber,
  UpdateControllerScratchRange,
  UpdateControllerCaptchaRange,
  getNativeAds,
  updateNativeAds,
  addNativeAds,
  deleteNativeAds,
  getFullScreenAds,
  updateFullScreenAds,
  addFullScreenAds,
  deleteFullScreenAds,
  getBannerAds,
  updateBannerAds,
  addBannerAds,
  deleteBannerAds,
  deleteInhouseAds,
  addInhouseAds,
  updateInhouseAds,
  getInhouseAds,
  getWithdrawCard,
  deleteWithdrawCard,
  addWithdrawCard,
  updateWithdrawCard,
  getOpenAds,
  addOpenAds,
  updateOpenAds,
  deleteOpenAds,
  getRewardAds,
  addRewardAds,
  deleteRewardAds,
  updateRewardAds,
  GetCashTask,
  InsertCashTask,
  UpdateCashTask,
  DeleteCashTask,
  GetUserWithdraw,
  DeleteUserWithdraw,
  UserWithdrawAccept,
};
